import { GET_KNOWLEDGE_FAVORIS } from "../actions/knowledgeFav.actions";

const initialState = {};

export default function knowledgeFav(state = initialState, action) {
  return action.type === GET_KNOWLEDGE_FAVORIS ? action.payload : state;
}
